import React from "react";
import { JobForm } from "./Forms/JobForm";
import { useCreateJobMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateJob = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
    },
  });

  const { mutate: createJob, isPending } = useCreateJobMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createJob(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_JOB")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <JobForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_JOB")}
              </>
            ) : (
              t("CREATE_JOB")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};
